import { useState, useRef, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Box,
  Badge,
  Divider,
  Chip,
} from "@mui/material";

import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CommonButton from "../common/CommonButton/CommonButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from "@mui/icons-material/History";
import Button from "@mui/material/Button";
import HistoryModal from "../../pages/GradeReports/ReviewReport/HistoryModal";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { ROLES, useAuth } from "../auth/AuthProvider";

export default function Head({ pathProps }) {
  console.log("Path Props in Head: ", pathProps);

  const { state, pathname } = useLocation();
  console.log("HEAD NAV STATE:", state); // ✅ ADD HERE
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const isCustomReport =
    pathProps.title && pathProps.title?.startsWith("Monthly, ") || pathProps.title?.startsWith("Quarterly, ") || pathProps.title?.startsWith("Annual, ") || pathProps.title?.startsWith("Custom, ") || pathProps?.pathname?.includes("/grade-reports/");
  const { isAuthenticated, user, groups, role, handleLogout, authToken, handleLogin } = useAuth();

  const isCreateRequest =
    (pathProps?.title && pathProps?.title.startsWith("New Report Request")) ||
    pathProps?.pathname?.includes("/create-request/companies") ||
    pathProps?.pathname?.includes("/create-request/report");
  const isCompanyPage = pathProps?.isCompanyPage || pathProps?.pathname?.startsWith("/company/");


  const isReviewReport = pathname?.includes("/review-report");
  const isOverviewPage = pathname?.includes("/overview");
  const [historyOpen, setHistoryOpen] = useState(false);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map(part => part[0])
      .join("")
      .toUpperCase();
  };

  const initials = getInitials(user?.name);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const arrowButtonStyles = {
    padding: 0,
    margin: 0,
    minWidth: "0px",
    position: "relative",
    left: "2px",
  };
  const isPartner = role === ROLES.PARTNER;
  const reportTypeTitle =
  pathProps?.title ||
  state?.settingsData?.report_type ||
  "";

const reportName =
  state?.reportName ||
  state?.settingsData?.report_name ||
  "";

const headerTitle = (() => {
  // Review report page
  if (isReviewReport) {
    return reportName || reportTypeTitle || "Review Report";
  }

  // If both exist
  if (reportTypeTitle && reportName) {
    return `${reportTypeTitle} ${reportName}`;
  }

  // If only one exists
  return reportTypeTitle || reportName || "Report";
})();

// Remove duplicate consecutive words like:
// "test_prod test_prod" -> "test_prod"
const cleanedHeaderTitle = headerTitle
  .replace(/\b([a-zA-Z0-9_]+)\s+\1\b/g, "$1")
  .replace(/,\s*,/g, ",")
  .replace(/^undefined,?\s*/i, "")
  .trim();

const formattedDueDate = (() => {
  const rawDate = state?.settingsData?.due_date;

  if (!rawDate) return "N/A";

  try {
    return new Date(rawDate).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return "N/A";
  }
})();

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: "#FAFAFA",
          color: "#000",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Left title */}
          <Box display="flex" alignItems="center" gap={2}>
            {isCustomReport && (
              <CommonButton
                variant="contained"
                size="medium"
                color="secondary"
                sx={arrowButtonStyles}
                onClick={() => navigate("/activity-reports")}
              >
                <ListItemIcon>
                  <ArrowBackIcon sx={{ width: "30px" }} />
                </ListItemIcon>
              </CommonButton>
            )}
            {/* Back button for Company Pages - NEW */}
            {isCompanyPage && (
              <CommonButton
                variant="contained"
                size="medium"
                color="secondary"
                sx={arrowButtonStyles}
                onClick={() => navigate("/portfolio")}
              >
                <ListItemIcon>
                  <ArrowBackIcon sx={{ width: "30px" }} />
                </ListItemIcon>
              </CommonButton>
            )}



            {isCreateRequest && (
              <CommonButton
                variant="contained"
                size="medium"
                color="secondary"
                sx={arrowButtonStyles}
                onClick={() => navigate("/activity-reports")}
              >
                <ListItemIcon>
                  <CloseIcon sx={{ width: "30px" }} />
                </ListItemIcon>
              </CommonButton>
            )}

            <Typography variant="h6" fontWeight={600}>
              {cleanedHeaderTitle}
            </Typography>

            {isCustomReport && !isReviewReport && (
              <Chip
                label={`Due ${formattedDueDate}`}
                size="small"
                sx={{
                  ml: 1,
                  height: 20,
                  fontSize: "0.7rem",
                  backgroundColor: "#D8E6F0",
                  borderBottom: "1px solid #5A60664D",
                  color: "primary.main",
                }}
              />
            )}
          </Box>

          {/* Right section */}
          <Box display="flex" alignItems="center" gap={2}>
            {/* {isCustomReport && !state?.reviewMode && (
              <CommonButton
                variant="outlined"
                onClick={() => {
                  // Assuming you have the report ID available, e.g., from pathProps
                  //const reportId = pathProps.reportId || "current-report-id";
                  const reportId = state?.requestId;

                  // Redirect to Step 1 of the multi-step flow
                  navigate(`/create-request/${reportId}/settings`, {
                    state: {
                      ...state, // 🔥 preserve everything
                      requestId: reportId,
                      settingsData: state?.settingsData,
                      companiesData: state?.companiesData?.length
                        ? state.companiesData
                        : state?.settingsData?.company?.length
                          ? state.settingsData.company
                          : [],
                      reportData: state?.reportData || null,
                      isEditMode: true, // ADD THIS FLAG
                    }
                  });
                }}
                size="medium"
              >
                <SettingsIcon />
                {isPartner ? " Shared Requests" : " Request Settings"}
              </CommonButton>
            )} */}

            {isCustomReport && !state?.reviewMode && !isPartner && !isReviewReport && (
              <CommonButton
                variant="outlined"
                onClick={() => {
                  // Assuming you have the report ID available, e.g., from pathProps
                  //const reportId = pathProps.reportId || "current-report-id";
                  const reportId = state?.requestId;

                  // Redirect to Step 1 of the multi-step flow
                  navigate(`/create-request/${reportId}/settings`, {
                    state: {
                      ...state, // 🔥 preserve everything
                      requestId: reportId,
                      settingsData: state?.settingsData,
                      companiesData: state?.companiesData?.length
                        ? state.companiesData
                        : state?.settingsData?.company?.length
                          ? state.settingsData.company
                          : [],
                      reportData: state?.reportData || null,
                      isEditMode: true, // ADD THIS FLAG
                    }
                  });
                }}
                size="medium"
              >
                <SettingsIcon />
                {" Request Settings"}
              </CommonButton>
            )}

            {/* History Button - Only show on ReviewReport page */}
            {(isReviewReport || isOverviewPage) && (
              <Button
                variant="outlined"
                startIcon={<HistoryIcon />}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: "#FFFFFF",
                  color: "#111827",
                  border: "1px solid #E5E7EB",
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "14px",
                  px: 2,
                  py: 1,
                  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                  "&:hover": {
                    backgroundColor: "#F9FAFB",
                    border: "1px solid #D1D5DB",
                    color: "#111827",
                    "& .MuiButton-startIcon": {
                      color: "#111827",
                    },
                  },
                }}
                onClick={() => setHistoryOpen(true)}
              >
                History
              </Button>
            )}

            {/* Notifications */}
            <IconButton>
              <Badge
                color="warning"
                variant="dot"
                overlap="circular"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <NotificationsOutlinedIcon />
              </Badge>
            </IconButton>

            {/* Avatar + dropdown */}
            {!isCustomReport && !isCreateRequest && (
              <Box display="flex" alignItems="center">
                <IconButton onClick={handleOpen}>
                  {isAuthenticated && (
                    <Avatar
                      sx={{
                        bgcolor: "teal",
                        width: 32,
                        height: 32,
                        fontSize: 14,
                      }}
                    >
                      {initials}
                    </Avatar>
                  )}
                  <KeyboardArrowDownIcon />
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    sx: {
                      width: 160,
                      mt: 1,
                    },
                  }}
                >
                  <MenuItem onClick={handleClose}>Profile</MenuItem>
                  <MenuItem onClick={handleClose}>Settings</MenuItem>
                  <Divider />
                  {/* <MenuItem onClick={authToken ? handleLogout : handleLogin}>
                    {authToken ? "Logout" : "Login"}
                  </MenuItem> */}
                  <MenuItem onClick={isAuthenticated ? handleLogout : handleLogin}>
                    {isAuthenticated ? "Logout" : "Login"}
                  </MenuItem>
                </Menu>
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {(isReviewReport || isOverviewPage) && (
        <HistoryModal
          open={historyOpen}
          onClose={() => setHistoryOpen(false)}
          companyName={state?.companyName}
        />
      )}
    </>
  );
}
